import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'

import Layout from '../views/layout/Layout.vue'

// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location: any) {
  return (originalPush.call(this, location) as any).catch((err: any) => err)
}

Vue.use(VueRouter)

// ***************************  Dashboard路由  ***************************
export const dashboardRouters: RouteConfig[] = [
  {
    path: '/dashboard',
    component: () => import('@/views/Dashboard.vue'),
    meta: { hidden: true }
  }
]

// ***************************  通用路由  ***************************
// 普通用户菜单(所有人可见),所有工单类型通用
export const constantRoutes: RouteConfig[] = [
  // { path: '/login', component: () => import('@/views/login/index.vue'), meta: { hidden: true } },
  {
    path: '/404',
    component: () =>
      import(/* webpackChunkName: "404" */ '@/views/error/404.vue'),
    meta: { hidden: true }
  },
  {
    path: '/jumper',
    name: 'jumper',
    component: () => import('@/views/Jumper.vue'),
    meta: { hidden: true }
  },
  {
    path: '/createIndex',
    name: 'createIndex',
    component: () => import('@/views/CreateIndex.vue'),
    meta: { hidden: true }
  },
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    name: 'home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/index.vue'),
        meta: { title: '首页', icon: 'index' }
      }
    ]
  },
  // 工单详情
  {
    path: '/orderDetail',
    component: Layout,
    name: 'orderDetail',
    meta: {
      title: '',
      icon: 'wodegongdan',
      hidden: true
    },
    children: [
      {
        path: '/order/detail/:ticketType/:tid',
        name: 'orderDetailIndex',
        component: () => import('@/views/orderDetail/index.vue'),
        meta: { title: '工单详情', icon: 'wodegongdan' }
      }
    ]
  },
  // 满意度评价
  {
    path: '/rate',
    component: Layout,
    redirect: '/rate/:ticketType/:tid',
    name: 'orderRate',
    children: [
      {
        path: '/rate/:ticketType/:tid',
        name: 'orderRateIndex',
        component: () => import('@/views/rate/index.vue'),
        meta: { title: '满意度评价', icon: 'wodegongdan', hidden: true }
      }
    ]
  }
]

// 普通管理员菜单
export const managerRouter: RouteConfig[] = [
  // 基础配置
  {
    path: '/config',
    component: Layout,
    redirect: '/config/all',
    name: 'config',
    children: [
      {
        path: 'all',
        name: 'tutorConfig',
        component: () => import('@/views/config/index.vue'),
        meta: { title: '基础配置', icon: 'peizhi' },
        children: [
          {
            path: 'area/:id',
            name: 'areaConfig',
            component: () => import('@/views/config/area/building.vue'),
            meta: {
              title: '基地列表',
              hidden: true,
              activeMenu: '/config/all'
            }
          },
          {
            path: 'strategy/:id',
            name: 'strategyConfig',
            component: () => import('@/views/config/area/strategy.vue'),
            meta: {
              title: '基地列表',
              hidden: true,
              activeMenu: '/config/all'
            }
          }
        ]
      }
    ]
  }
]

// ***************************  IT工单路由  ***************************

// IT工单路由 - 所有人可见
export const ITAllowAnyRoutes: RouteConfig[] = [
  {
    path: '/newOrder',
    component: Layout,
    redirect: '/newOrder/tutor',
    name: 'newOrder',
    meta: {
      title: '新建工单',
      icon: 'xinjianwendang'
    },
    children: [
      {
        path: 'tutor',
        component: () => import('@/views/newOrderIT/tutor.vue'),
        name: 'tutor',
        meta: { title: '新建工单', icon: 'xinjianwendang' }
      }
      // {
      //   path: 'lp',
      //   component: () => import('@/views/newOrder/tutor.vue'),
      //   name: 'lp',
      //   meta: { title: 'LP(学规)工单' }
      // }
    ]
  },
  // 发起人-我的工单
  {
    path: '/createdOrders',
    component: Layout,
    redirect: '/createdOrders/all',
    name: 'createdOrders',
    meta: {
      title: '',
      icon: 'wodegongdan'
    },
    children: [
      {
        path: 'all',
        name: 'myCreateedOrders',
        component: () => import('@/views/myOrderIT/allCreated.vue'),
        meta: { title: '我发起的', icon: 'wodegongdan' }
      }
    ]
  }
]

// IT 保障菜单
export const ITwaiterRouter: RouteConfig[] = [
  // 受理人-我的工单
  {
    path: '/managedOrder',
    component: Layout,
    redirect: '/managedOrder/all',
    name: 'managedOrder',
    children: [
      {
        path: 'all',
        name: 'myManagedOrders',
        component: () => import('@/views/myOrderIT/allManaged.vue'),
        meta: { title: '工单管理', icon: 'liebiao' }
      }
    ]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/own',
    name: 'statistic',
    meta: {
      title: '统计看板',
      icon: 'kanban'
    },
    children: [
      {
        path: 'own',
        name: 'ownStatistic',
        component: () => import('@/views/statisticIT/index.vue'),
        meta: { title: '个人看板' }
      },
      {
        path: 'area',
        name: 'areaStatistic',
        component: () => import('@/views/statisticIT/index.vue'),
        meta: { title: '地区看板' }
      }
    ]
  }
]

// IT 超级管理员菜单
export const ITadminRouter: RouteConfig[] = [
  // 工单中心
  {
    path: '/ordersCenter',
    component: Layout,
    redirect: '/ordersCenter/all',
    name: 'ordersCenter',
    meta: {
      title: '工单中心',
      icon: 'quanbu'
    },
    children: [
      {
        path: 'all',
        component: () => import('@/views/orderCenterIT/all.vue'),
        name: 'allOrders',
        meta: { title: '所有工单', icon: 'quanbu' }
      },
      {
        path: 'statistic',
        name: 'allStatistic',
        component: () => import('@/views/statisticIT/index.vue'),
        meta: { title: '所有工单统计', hidden: false }
      }
    ]
  }
]

// ***************************  直播保障工单路由  ***************************

// 直播保障 工单路由 - 所有人可见
export const LiveAllowAnyRoutes: RouteConfig[] = [
  {
    path: '/newOrder',
    component: Layout,
    redirect: '/newOrder/tutor',
    name: 'newOrder',
    meta: {
      title: '新建工单',
      icon: 'xinjianwendang'
    },
    children: [
      {
        path: 'tutor',
        component: () => import('@/views/newOrderLive/tutor.vue'),
        name: 'tutor',
        meta: {
          title: '新建工单',
          icon: 'xinjianwendang'
        }
      }
    ]
  },
  // 发起人-我的工单
  {
    path: '/createdOrders',
    component: Layout,
    redirect: '/createdOrders/all',
    name: 'createdOrders',
    meta: {
      title: '',
      icon: 'wodegongdan'
    },
    children: [
      {
        path: 'all',
        name: 'myCreateedOrders',
        component: () => import('@/views/myOrderLive/allCreated.vue'),
        meta: { title: '我发起的', icon: 'wodegongdan' }
      }
    ]
  }
]

// 直播保障 保障菜单
export const LivewaiterRouter: RouteConfig[] = [
  // 受理人-我的工单
  {
    path: '/managedOrder',
    component: Layout,
    redirect: '/managedOrder/all',
    name: 'managedOrder',
    children: [
      {
        path: 'all',
        name: 'myManagedOrders',
        component: () => import('@/views/myOrderLive/allManaged.vue'),
        meta: { title: '工单管理', icon: 'liebiao' }
      }
    ]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/own',
    name: 'statistic',
    meta: {
      title: '统计看板',
      icon: 'kanban',
      alwaysShow: true
    },
    children: [
      {
        path: 'own',
        name: 'ownStatistic',
        component: () => import('@/views/statisticLive/index.vue'),
        meta: { title: '个人看板' }
      }
    ]
  },
  {
    path: '/manualWork',
    component: Layout,
    redirect: '/manualWork/add',
    name: 'manualWork',
    children: [
      {
        path: 'add',
        name: 'addManualWork',
        component: () => import('@/views/newOrderLive/manualWork.vue'),
        meta: { title: '手动录入', icon: 'group6' }
      }
    ]
  }
]

// 直播保障 超级管理员菜单
export const LiveadminRouter: RouteConfig[] = [
  // 工单中心
  {
    path: '/ordersCenter',
    component: Layout,
    redirect: '/ordersCenter/all',
    name: 'ordersCenter',
    meta: {
      title: '工单中心',
      icon: 'quanbu'
    },
    children: [
      {
        path: 'all',
        component: () => import('@/views/orderCenterLive/all.vue'),
        name: 'allOrders',
        meta: { title: '所有工单' }
      },
      {
        path: 'statistic',
        name: 'allStatistic',
        component: () => import('@/views/statisticLive/index.vue'),
        meta: { title: '所有工单统计' }
      }
    ]
  }
]

// ***************************  网络工单路由  ***************************

export const NetWorkAllowAnyRoutes: RouteConfig[] = [
  {
    path: '/newOrder',
    component: Layout,
    redirect: '/newOrder/tutor',
    name: 'newOrder',
    meta: {
      title: '新建工单',
      icon: 'xinjianwendang'
    },
    children: [
      {
        path: 'tutor',
        component: () => import('@/views/newOrderNetwork/tutor.vue'),
        name: 'tutor',
        meta: {
          title: '新建工单',
          icon: 'xinjianwendang'
        }
      }
    ]
  },
  // 发起人-我的工单
  {
    path: '/createdOrders',
    component: Layout,
    redirect: '/createdOrders/all',
    name: 'createdOrders',
    meta: {
      title: '',
      icon: 'wodegongdan'
    },
    children: [
      {
        path: 'all',
        name: 'myCreateedOrders',
        component: () => import('@/views/myOrderNetwork/allCreated.vue'),
        meta: { title: '我发起的', icon: 'wodegongdan' }
      }
    ]
  }
]

// 网络工单 保障菜单
export const NetworkWaiterRouter: RouteConfig[] = [
  //   // 受理人-我的工单
  {
    path: '/managedOrder',
    component: Layout,
    redirect: '/managedOrder/all',
    name: 'managedOrder',
    children: [
      {
        path: 'all',
        name: 'myManagedOrders',
        component: () => import('@/views/myOrderNetwork/allManaged.vue'),
        meta: { title: '工单管理', icon: 'liebiao' }
      }
    ]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/own',
    name: 'statistic',
    meta: {
      title: '统计看板',
      icon: 'kanban',
      alwaysShow: true
    },
    children: [
      {
        path: 'own',
        name: 'ownStatistic',
        component: () => import('@/views/statisticNetwork/index.vue'),
        meta: { title: '个人看板' }
      },
      {
        path: 'area',
        name: 'areaStatistic',
        component: () => import('@/views/statisticNetwork/index.vue'),
        meta: { title: '地区看板', hidden: false }
      },
      {
        path: 'nts',
        name: 'ntsStatistic',
        component: () => import('@/views/statisticNetworkTs/index.vue'),
        meta: { title: '网络事务工单看板', hidden: false }
      }
    ]
  },
  {
    path: '/manualWork',
    component: Layout,
    redirect: '/manualWork/add',
    name: 'manualWork',
    children: [
      {
        path: 'add',
        name: 'addManualWork',
        component: () => import('@/views/newOrderNetwork/manualWork.vue'),
        meta: { title: '手动录入', icon: 'group6' }
      }
    ]
  }
]

// 网络工单 超级管理员菜单
export const NetworkAdminRouter: RouteConfig[] = [
  // 工单中心
  {
    path: '/ordersCenter',
    component: Layout,
    redirect: '/ordersCenter/all',
    name: 'ordersCenter',
    meta: {
      title: '工单中心',
      icon: 'quanbu'
    },
    children: [
      {
        path: 'all',
        component: () => import('@/views/orderCenterNetwork/all.vue'),
        name: 'allOrders',
        meta: { title: '所有工单' }
      },
      {
        path: 'statistic',
        name: 'allStatistic',
        component: () => import('@/views/statisticNetwork/index.vue'),
        meta: { title: '所有工单统计' }
      }
    ]
  }
]

// ***************************  行政工单  ***************************

export const AdministrationAllowAnyRoutes: RouteConfig[] = [
  {
    path: '/newOrder',
    component: Layout,
    redirect: '/newOrder/tutor',
    name: 'newOrder',
    meta: {
      title: '新建工单',
      icon: 'xinjianwendang'
    },
    children: [
      {
        path: 'tutor',
        component: () => import('@/views/newOrderAdministration/tutor.vue'),
        name: 'tutor',
        meta: {
          title: '新建工单',
          icon: 'xinjianwendang'
        }
      }
    ]
  },
  // 发起人-我的工单
  {
    path: '/createdOrders',
    component: Layout,
    redirect: '/createdOrders/all',
    name: 'createdOrders',
    meta: {
      title: '',
      icon: 'wodegongdan'
    },
    children: [
      {
        path: 'all',
        name: 'myCreateedOrders',
        component: () => import('@/views/myOrderAdministration/allCreated.vue'),
        meta: { title: '我发起的', icon: 'wodegongdan' }
      }
    ]
  }
]

// 行政工单 保障菜单
export const AdministrationWaiterRouter: RouteConfig[] = [
  //   // 受理人-我的工单
  {
    path: '/managedOrder',
    component: Layout,
    redirect: '/managedOrder/all',
    name: 'managedOrder',
    children: [
      {
        path: 'all',
        name: 'myManagedOrders',
        component: () => import('@/views/myOrderAdministration/allManaged.vue'),
        meta: { title: '工单管理', icon: 'liebiao' }
      }
    ]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/own',
    name: 'statistic',
    meta: {
      title: '统计看板',
      icon: 'kanban',
      alwaysShow: true
    },
    children: [
      {
        path: 'own',
        name: 'ownStatistic',
        component: () => import('@/views/statisticAdministration/index.vue'),
        meta: { title: '个人看板' }
      },
      {
        path: 'area',
        name: 'areaStatistic',
        component: () => import('@/views/statisticAdministration/index.vue'),
        meta: { title: '地区看板', hidden: false }
      }
    ]
  },
  {
    path: '/manualWork',
    component: Layout,
    redirect: '/manualWork/add',
    name: 'manualWork',
    children: [
      {
        path: 'add',
        name: 'addManualWork',
        component: () =>
          import('@/views/newOrderAdministration/manualWork.vue'),
        meta: { title: '手动录入', icon: 'group6' }
      }
    ]
  }
]

// 行政工单 超级管理员菜单
export const AdministrationAdminRouter: RouteConfig[] = [
  // 工单中心
  {
    path: '/ordersCenter',
    component: Layout,
    redirect: '/ordersCenter/all',
    name: 'ordersCenter',
    meta: {
      title: '工单中心',
      icon: 'quanbu'
    },
    children: [
      {
        path: 'all',
        component: () => import('@/views/orderCenterAdministration/all.vue'),
        name: 'allOrders',
        meta: { title: '所有工单' }
      },
      {
        path: 'statistic',
        name: 'allStatistic',
        component: () => import('@/views/statisticAdministration/index.vue'),
        meta: { title: '所有工单统计' }
      }
    ]
  }
]

// ***************************  服务保障工单  ***************************

export const FuWuBaoZhangAllowAnyRoutes: RouteConfig[] = [
  {
    path: '/newOrder',
    component: Layout,
    redirect: '/newOrder/tutor',
    name: 'newOrder',
    meta: {
      title: '新建工单',
      icon: 'xinjianwendang'
    },
    children: [
      {
        path: 'tutor',
        component: () => import('@/views/newOrderFuWuBaoZhang/tutor.vue'),
        name: 'tutor',
        meta: {
          title: '新建工单',
          icon: 'xinjianwendang'
        }
      }
    ]
  },
  // 发起人-我的工单
  {
    path: '/createdOrders',
    component: Layout,
    redirect: '/createdOrders/all',
    name: 'createdOrders',
    meta: {
      title: '',
      icon: 'wodegongdan'
    },
    children: [
      {
        path: 'all',
        name: 'myCreateedOrders',
        component: () => import('@/views/myOrderFuWuBaoZhang/allCreated.vue'),
        meta: { title: '我发起的', icon: 'wodegongdan' }
      }
    ]
  }
]

// 服务保障工单 保障菜单
export const FuWuBaoZhangWaiterRouter: RouteConfig[] = [
  //   // 受理人-我的工单
  {
    path: '/managedOrder',
    component: Layout,
    redirect: '/managedOrder/all',
    name: 'managedOrder',
    children: [
      {
        path: 'all',
        name: 'myManagedOrders',
        component: () => import('@/views/myOrderFuWuBaoZhang/allManaged.vue'),
        meta: { title: '工单管理', icon: 'liebiao' }
      }
    ]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/own',
    name: 'statistic',
    meta: {
      title: '统计看板',
      icon: 'kanban',
      alwaysShow: true
    },
    children: [
      {
        path: 'own',
        name: 'ownStatistic',
        component: () => import('@/views/statisticFuWuBaoZhang/index.vue'),
        meta: { title: '个人看板' }
      },
      {
        path: 'area',
        name: 'areaStatistic',
        component: () => import('@/views/statisticFuWuBaoZhang/index.vue'),
        meta: { title: '地区看板', hidden: false }
      }
    ]
  },
  {
    path: '/manualWork',
    component: Layout,
    redirect: '/manualWork/add',
    name: 'manualWork',
    children: [
      {
        path: 'add',
        name: 'addManualWork',
        component: () =>
          import('@/views/newOrderFuWuBaoZhang/manualWork.vue'),
        meta: { title: '手动录入', icon: 'group6' }
      }
    ]
  }
]

// 服务保障工单 超级管理员菜单
export const FuWuBaoZhangAdminRouter: RouteConfig[] = [
  // 工单中心
  {
    path: '/ordersCenter',
    component: Layout,
    redirect: '/ordersCenter/all',
    name: 'ordersCenter',
    meta: {
      title: '工单中心',
      icon: 'quanbu'
    },
    children: [
      {
        path: 'all',
        component: () => import('@/views/orderCenterFuWuBaoZhang/all.vue'),
        name: 'allOrders',
        meta: { title: '所有工单' }
      },
      {
        path: 'statistic',
        name: 'allStatistic',
        component: () => import('@/views/statisticFuWuBaoZhang/index.vue'),
        meta: { title: '所有工单统计' }
      }
    ]
  }
]

// ***************************  采购管理工单  ***************************

export const CaiGouGuanLiAllowAnyRoutes: RouteConfig[] = [
  {
    path: '/newOrder',
    component: Layout,
    redirect: '/newOrder/tutor',
    name: 'newOrder',
    meta: {
      title: '新建工单',
      icon: 'xinjianwendang'
    },
    children: [
      {
        path: 'tutor',
        component: () => import('@/views/newOrderCaiGouGuanLi/tutor.vue'),
        name: 'tutor',
        meta: {
          title: '新建工单',
          icon: 'xinjianwendang'
        }
      }
    ]
  },
  // 发起人-我的工单
  {
    path: '/createdOrders',
    component: Layout,
    redirect: '/createdOrders/all',
    name: 'createdOrders',
    meta: {
      title: '',
      icon: 'wodegongdan'
    },
    children: [
      {
        path: 'all',
        name: 'myCreateedOrders',
        component: () => import('@/views/myOrderCaiGouGuanLi/allCreated.vue'),
        meta: { title: '我发起的', icon: 'wodegongdan' }
      }
    ]
  }
]

// 服务保障工单 保障菜单
export const CaiGouGuanLiWaiterRouter: RouteConfig[] = [
  //   // 受理人-我的工单
  {
    path: '/managedOrder',
    component: Layout,
    redirect: '/managedOrder/all',
    name: 'managedOrder',
    children: [
      {
        path: 'all',
        name: 'myManagedOrders',
        component: () => import('@/views/myOrderCaiGouGuanLi/allManaged.vue'),
        meta: { title: '工单管理', icon: 'liebiao' }
      }
    ]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/own',
    name: 'statistic',
    meta: {
      title: '统计看板',
      icon: 'kanban',
      alwaysShow: true
    },
    children: [
      {
        path: 'own',
        name: 'ownStatistic',
        component: () => import('@/views/statisticCaiGouGuanLi/index.vue'),
        meta: { title: '个人看板' }
      },
      {
        path: 'area',
        name: 'areaStatistic',
        component: () => import('@/views/statisticCaiGouGuanLi/index.vue'),
        meta: { title: '地区看板', hidden: false }
      }
    ]
  },
  {
    path: '/manualWork',
    component: Layout,
    redirect: '/manualWork/add',
    name: 'manualWork',
    children: [
      {
        path: 'add',
        name: 'addManualWork',
        component: () =>
          import('@/views/newOrderCaiGouGuanLi/manualWork.vue'),
        meta: { title: '手动录入', icon: 'group6' }
      }
    ]
  }
]

// 服务保障工单 超级管理员菜单
export const CaiGouGuanLiAdminRouter: RouteConfig[] = [
  // 工单中心
  {
    path: '/ordersCenter',
    component: Layout,
    redirect: '/ordersCenter/all',
    name: 'ordersCenter',
    meta: {
      title: '工单中心',
      icon: 'quanbu'
    },
    children: [
      {
        path: 'all',
        component: () => import('@/views/orderCenterCaiGouGuanLi/all.vue'),
        name: 'allOrders',
        meta: { title: '所有工单' }
      },
      {
        path: 'statistic',
        name: 'allStatistic',
        component: () => import('@/views/statisticCaiGouGuanLi/index.vue'),
        meta: { title: '所有工单统计' }
      }
    ]
  }
]
// ***************************  生产管理工单  ***************************

export const ShengChanGuanLiAllowAnyRoutes: RouteConfig[] = [
  {
    path: '/newOrder',
    component: Layout,
    redirect: '/newOrder/tutor',
    name: 'newOrder',
    meta: {
      title: '新建工单',
      icon: 'xinjianwendang'
    },
    children: [
      {
        path: 'tutor',
        component: () => import('@/views/newOrderShengChanGuanLi/tutor.vue'),
        name: 'tutor',
        meta: {
          title: '新建工单',
          icon: 'xinjianwendang'
        }
      }
    ]
  },
  // 发起人-我的工单
  {
    path: '/createdOrders',
    component: Layout,
    redirect: '/createdOrders/all',
    name: 'createdOrders',
    meta: {
      title: '',
      icon: 'wodegongdan'
    },
    children: [
      {
        path: 'all',
        name: 'myCreateedOrders',
        component: () => import('@/views/myOrderShengChanGuanLi/allCreated.vue'),
        meta: { title: '我发起的', icon: 'wodegongdan' }
      }
    ]
  }
]

// 服务保障工单 保障菜单
export const ShengChanGuanLiWaiterRouter: RouteConfig[] = [
  //   // 受理人-我的工单
  {
    path: '/managedOrder',
    component: Layout,
    redirect: '/managedOrder/all',
    name: 'managedOrder',
    children: [
      {
        path: 'all',
        name: 'myManagedOrders',
        component: () => import('@/views/myOrderShengChanGuanLi/allManaged.vue'),
        meta: { title: '工单管理', icon: 'liebiao' }
      }
    ]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/own',
    name: 'statistic',
    meta: {
      title: '统计看板',
      icon: 'kanban',
      alwaysShow: true
    },
    children: [
      {
        path: 'own',
        name: 'ownStatistic',
        component: () => import('@/views/statisticShengChanGuanLi/index.vue'),
        meta: { title: '个人看板' }
      },
      {
        path: 'area',
        name: 'areaStatistic',
        component: () => import('@/views/statisticShengChanGuanLi/index.vue'),
        meta: { title: '地区看板', hidden: false }
      }
    ]
  },
  {
    path: '/manualWork',
    component: Layout,
    redirect: '/manualWork/add',
    name: 'manualWork',
    children: [
      {
        path: 'add',
        name: 'addManualWork',
        component: () =>
          import('@/views/newOrderShengChanGuanLi/manualWork.vue'),
        meta: { title: '手动录入', icon: 'group6' }
      }
    ]
  }
]

// 服务保障工单 超级管理员菜单
export const ShengChanGuanLiAdminRouter: RouteConfig[] = [
  // 工单中心
  {
    path: '/ordersCenter',
    component: Layout,
    redirect: '/ordersCenter/all',
    name: 'ordersCenter',
    meta: {
      title: '工单中心',
      icon: 'quanbu'
    },
    children: [
      {
        path: 'all',
        component: () => import('@/views/orderCenterShengChanGuanLi/all.vue'),
        name: 'allOrders',
        meta: { title: '所有工单' }
      },
      {
        path: 'statistic',
        name: 'allStatistic',
        component: () => import('@/views/statisticShengChanGuanLi/index.vue'),
        meta: { title: '所有工单统计' }
      }
    ]
  }
]


// ***************************  商品运营工单  ***************************

export const ShangPinYunYingAllowAnyRoutes: RouteConfig[] = [
  {
    path: '/newOrder',
    component: Layout,
    redirect: '/newOrder/tutor',
    name: 'newOrder',
    meta: {
      title: '新建工单',
      icon: 'xinjianwendang'
    },
    children: [
      {
        path: 'tutor',
        component: () => import('@/views/newOrderShangPinYunYing/tutor.vue'),
        name: 'tutor',
        meta: {
          title: '新建工单',
          icon: 'xinjianwendang'
        }
      }
    ]
  },
  // 发起人-我的工单
  {
    path: '/createdOrders',
    component: Layout,
    redirect: '/createdOrders/all',
    name: 'createdOrders',
    meta: {
      title: '',
      icon: 'wodegongdan'
    },
    children: [
      {
        path: 'all',
        name: 'myCreateedOrders',
        component: () => import('@/views/myOrderShangPinYunYing/allCreated.vue'),
        meta: { title: '我发起的', icon: 'wodegongdan' }
      }
    ]
  }
]

// 服务保障工单 保障菜单
export const ShangPinYunYingWaiterRouter: RouteConfig[] = [
  //   // 受理人-我的工单
  {
    path: '/managedOrder',
    component: Layout,
    redirect: '/managedOrder/all',
    name: 'managedOrder',
    children: [
      {
        path: 'all',
        name: 'myManagedOrders',
        component: () => import('@/views/myOrderShangPinYunYing/allManaged.vue'),
        meta: { title: '工单管理', icon: 'liebiao' }
      }
    ]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/own',
    name: 'statistic',
    meta: {
      title: '统计看板',
      icon: 'kanban',
      alwaysShow: true
    },
    children: [
      {
        path: 'own',
        name: 'ownStatistic',
        component: () => import('@/views/statisticShangPinYunYing/index.vue'),
        meta: { title: '个人看板' }
      },
      {
        path: 'area',
        name: 'areaStatistic',
        component: () => import('@/views/statisticShangPinYunYing/index.vue'),
        meta: { title: '地区看板', hidden: false }
      }
    ]
  },
  {
    path: '/manualWork',
    component: Layout,
    redirect: '/manualWork/add',
    name: 'manualWork',
    children: [
      {
        path: 'add',
        name: 'addManualWork',
        component: () =>
          import('@/views/newOrderShangPinYunYing/manualWork.vue'),
        meta: { title: '手动录入', icon: 'group6' }
      }
    ]
  }
]

// 服务保障工单 超级管理员菜单
export const ShangPinYunYingAdminRouter: RouteConfig[] = [
  // 工单中心
  {
    path: '/ordersCenter',
    component: Layout,
    redirect: '/ordersCenter/all',
    name: 'ordersCenter',
    meta: {
      title: '工单中心',
      icon: 'quanbu'
    },
    children: [
      {
        path: 'all',
        component: () => import('@/views/orderCenterShangPinYunYing/all.vue'),
        name: 'allOrders',
        meta: { title: '所有工单' }
      },
      {
        path: 'statistic',
        name: 'allStatistic',
        component: () => import('@/views/statisticShangPinYunYing/index.vue'),
        meta: { title: '所有工单统计' }
      }
    ]
  }
]

// ***************************  商品运营工单  ***************************

export const GongYingGuanLiAllowAnyRoutes: RouteConfig[] = [
  {
    path: '/newOrder',
    component: Layout,
    redirect: '/newOrder/tutor',
    name: 'newOrder',
    meta: {
      title: '新建工单',
      icon: 'xinjianwendang'
    },
    children: [
      {
        path: 'tutor',
        component: () => import('@/views/newOrderGongYingGuanLi/tutor.vue'),
        name: 'tutor',
        meta: {
          title: '新建工单',
          icon: 'xinjianwendang'
        }
      }
    ]
  },
  // 发起人-我的工单
  {
    path: '/createdOrders',
    component: Layout,
    redirect: '/createdOrders/all',
    name: 'createdOrders',
    meta: {
      title: '',
      icon: 'wodegongdan'
    },
    children: [
      {
        path: 'all',
        name: 'myCreateedOrders',
        component: () => import('@/views/myOrderGongYingGuanLi/allCreated.vue'),
        meta: { title: '我发起的', icon: 'wodegongdan' }
      }
    ]
  }
]

// 服务保障工单 保障菜单
export const GongYingGuanLiWaiterRouter: RouteConfig[] = [
  //   // 受理人-我的工单
  {
    path: '/managedOrder',
    component: Layout,
    redirect: '/managedOrder/all',
    name: 'managedOrder',
    children: [
      {
        path: 'all',
        name: 'myManagedOrders',
        component: () => import('@/views/myOrderGongYingGuanLi/allManaged.vue'),
        meta: { title: '工单管理', icon: 'liebiao' }
      }
    ]
  },
  {
    path: '/statistic',
    component: Layout,
    redirect: '/statistic/own',
    name: 'statistic',
    meta: {
      title: '统计看板',
      icon: 'kanban',
      alwaysShow: true
    },
    children: [
      {
        path: 'own',
        name: 'ownStatistic',
        component: () => import('@/views/statisticGongYingGuanLi/index.vue'),
        meta: { title: '个人看板' }
      },
      {
        path: 'area',
        name: 'areaStatistic',
        component: () => import('@/views/statisticGongYingGuanLi/index.vue'),
        meta: { title: '地区看板', hidden: false }
      }
    ]
  },
  {
    path: '/manualWork',
    component: Layout,
    redirect: '/manualWork/add',
    name: 'manualWork',
    children: [
      {
        path: 'add',
        name: 'addManualWork',
        component: () =>
          import('@/views/newOrderGongYingGuanLi/manualWork.vue'),
        meta: { title: '手动录入', icon: 'group6' }
      }
    ]
  }
]

// 服务保障工单 超级管理员菜单
export const GongYingGuanLiAdminRouter: RouteConfig[] = [
  // 工单中心
  {
    path: '/ordersCenter',
    component: Layout,
    redirect: '/ordersCenter/all',
    name: 'ordersCenter',
    meta: {
      title: '工单中心',
      icon: 'quanbu'
    },
    children: [
      {
        path: 'all',
        component: () => import('@/views/orderCenterGongYingGuanLi/all.vue'),
        name: 'allOrders',
        meta: { title: '所有工单' }
      },
      {
        path: 'statistic',
        name: 'allStatistic',
        component: () => import('@/views/statisticGongYingGuanLi/index.vue'),
        meta: { title: '所有工单统计' }
      }
    ]
  }
]


const createRouter = () =>
  new VueRouter({
    routes: constantRoutes
  })

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter();
  (router as any).matcher = (newRouter as any).matcher // reset router
}

export default router
